// Portal Onboarding Tour Steps
export const ONBOARDING_STEPS = {
    STEP_1: 1,
    STEP_2: 2,
    STEP_3: 3,
    STEP_4: 4,
    STEP_5: 5,
    STEP_6: 6,
}

// Step configuration with element selectors and content
export const ONBOARDING_STEP_CONFIG = {
    [ONBOARDING_STEPS.STEP_1]: {
        step: 1,
        title: 'Welcome to Scale Mediation Portal',
        content: 'This is your Profile section. You can manage all your profile-related settings here, including your personal information, rates, availability, and integrations.',
        element: '[data-onboarding="step-1-profile"]',
        position: 'bottom',
        route: '/account',
        blockTarget: true, // block clicks on highlight (Profile nav); user advances via Next only
    },
    [ONBOARDING_STEPS.STEP_2]: {
        step: 2,
        title: 'Add your mediation time',
        content: 'Set your timezone, morning slot, afternoon slot, and full day slot. Setting these up defines your availability slots so others can schedule sessions with you.',
        element: '[data-onboarding="step-2-mediation-time"]',
        position: 'bottom',
        route: '/account',
        blockTarget: false, // allow editing inputs in Mediation Time section
    },
    [ONBOARDING_STEPS.STEP_3]: {
        step: 3,
        title: 'Invoice Memo',
        position: 'bottom',
        route: '/account',
        blockTarget: false,
        element: '[data-onboarding="step-3-invoice-footer"]',
        subSteps: [
            {
                content: "This cancellation policy will appear on all invoices. You can update Invoice Footer as you'd like when you want.",
                element: '[data-onboarding="step-3-invoice-footer"]',
            },
            {
                content: "You can update Cancellation Policy as you'd like when you want.",
                element: '[data-onboarding="step-3-cancellation-policy"]',
            },
            {
                content: "You can update Additional Information as you'd like when you want.",
                element: '[data-onboarding="step-3-additional-info"]',
            },
        ],
    },
    [ONBOARDING_STEPS.STEP_4]: {
        step: 4,
        title: 'Car Info',
        position: 'bottom',
        route: '/account',
        routeState: { activeTab: 'carInfo' },
        blockTarget: false,
        element: '[data-onboarding="step-4-bio"]',
        subSteps: [
            { content: "You can update Bio as you'd like when you want.", element: '[data-onboarding="step-4-bio"]' },
            { content: "You can update C.A.R. Hourly Rate as you'd like when you want.", element: '[data-onboarding="step-4-car-hourly-rate"]' },
            { content: "You can update Practice Areas as you'd like when you want.", element: '[data-onboarding="step-4-practice-areas"]' },
            { content: "You can update Languages as you'd like when you want.", element: '[data-onboarding="step-4-languages"]' },
            { content: "You can update Education as you'd like when you want.", element: '[data-onboarding="step-4-education"]' },
            { content: "You can update Bar Admissions as you'd like when you want.", element: '[data-onboarding="step-4-bar-admissions"]' },
            { content: "You can update Awards as you'd like when you want.", element: '[data-onboarding="step-4-awards"]' },
        ],
    },
    [ONBOARDING_STEPS.STEP_5]: {
        step: 5,
        title: 'Schedule & availability',
        position: 'bottom',
        route: '/schedule',
        blockTarget: false,
        element: '[data-onboarding="step-5-schedule"]',
        subSteps: [
            {
                content: 'Open your dates by clicking on "Not Available" dates.',
                element: '[data-onboarding="step-5-not-available"]',
            },
            {
                content: 'You can change "Available" to "Not Available" by clicking those dates as well.',
                element: '[data-onboarding="step-5-available"]',
            },
            {
                content: 'Use the next/previous month button to switch months.',
                element: '[data-onboarding="step-5-month-nav"]',
            },
        ],
    },
}

// Total number of steps
export const TOTAL_ONBOARDING_STEPS = Object.keys(ONBOARDING_STEP_CONFIG).length

// Onboarding status values
export const ONBOARDING_STATUS = {
    NOT_STARTED: 0,
    IN_PROGRESS: 1,
    COMPLETED: 2,
    SKIPPED: 3,
}

// Get step config by step number
export const getStepConfig = (step) => {
    return ONBOARDING_STEP_CONFIG[step] || null
}

// Get next step
export const getNextStep = (currentStep) => {
    if (currentStep >= TOTAL_ONBOARDING_STEPS) {
        return null
    }
    return currentStep + 1
}

// Get previous step
export const getPreviousStep = (currentStep) => {
    if (currentStep <= 1) {
        return null
    }
    return currentStep - 1
}

// Check if step is valid
export const isValidStep = (step) => {
    return step >= 1 && step <= TOTAL_ONBOARDING_STEPS
}
